import { getTokens } from 'core/classes/helpers/StorageHelper'
import settings from 'src/config/settings'

import {
  IDescriptionQualityInitiative,
  IDescriptionQualityResult,
} from '../commonComponents/editorComponents/components/descriptionQuality/models'

interface ICheckDescriptionQualityResponse {
  status: 'success'
  data: IDescriptionQualityResult
}

const isDescriptionQualityResult = (value: unknown): value is IDescriptionQualityResult => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'score' in value &&
    typeof value.score === 'number' &&
    Number.isFinite(value.score) &&
    'reasons' in value &&
    Array.isArray(value.reasons) &&
    value.reasons.every((reason) => typeof reason === 'string')
  )
}

export const checkDescriptionQuality = async (
  initiative: IDescriptionQualityInitiative
): Promise<IDescriptionQualityResult> => {
  const [token] = getTokens()
  const response = await fetch(
    `${settings.httpsServices.partner360}/api/v0/keyInitiatives/checkQuality`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ initiative }),
    }
  )

  if (!response.ok) {
    throw new Error(`Description quality request failed with status ${response.status}`)
  }

  const result = (await response.json()) as Partial<ICheckDescriptionQualityResponse>

  if (result.status !== 'success' || !isDescriptionQualityResult(result.data)) {
    throw new Error('Description quality response has an invalid format')
  }

  return result.data
}
